<micro-lookup domain="smsc" obj="smscClusters" url="/smsc/smscClusters" [key]="smscClusterId" [link]="link"></micro-lookup>
